import React from 'react'
import { Link } from 'react-router-dom'

const Checkout = () => {
    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Checkout</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="checkout_page  ">
                <div className="container  ">
                    <div className="row ">
                        <div className="col-sm-8">
                            <div className="billing_form wow fadeInLeftBig" data-wow-duration="2s">
                                <h3>Billing Details</h3>
                                <form>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label>First Name*</label>
                                            <input type="text" name="fname" />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Last Name*</label>
                                            <input type="text" name="lname" />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Company Name (Optional)</label>
                                            <input type="text" name="companyname" />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Country / Region *</label>
                                            <input type="text" name="country" placeholder="United States" />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Street Address*</label>
                                            <input type="text" name="add1" placeholder="House Number and Street Name" />
                                            <input type="text" name="add2" placeholder="Apartment, Suite, unit etc" />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Town / City *</label>
                                            <input type="text" name="town" />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>State*</label>
                                            <input type="text" name="state" />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Zip*</label>
                                            <input type="text" name="zip" />
                                        </div>
                                        <div className="col-sm-6">
                                            <label>Phone*</label>
                                            <input type="number" name="phone" />
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Email Address*</label>
                                            <input type="email" name="email" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className=" col-sm-4">
                            <div className="cart_sidebar wow fadeInRightBig" data-wow-duration="2s">
                                <h3>Your Order</h3>
                                <h5 className="h-sub">Product</h5>
                                <ul className="cart_lst">
                                    <li>Name Here x1<span>$40.00</span></li>
                                    <li>Subtotal<span>$100.00</span></li>
                                </ul>
                                <h4>Shipping</h4>
                                <ul className="shipping-ul">
                                    <li>
                                        <input type="checkbox" name="free" id="free" />
                                        <label htmlFor="free">Free Shipping</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" name="local" id="local" />
                                        <label htmlFor="local">Local Pickup</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" name="flat" id="flat" />
                                        <label htmlFor="flat">Flat rate: $5.00</label>
                                    </li>
                                </ul>
                                <h5 className="h-sub mt-3">Total <span>$100.00</span></h5>
                                <h6 className="payment-h">Payment Method</h6>
                                <ul className="radiosss radiosss-payments">
                                    <li>
                                        <input type="radio" name="direct" id="direct" data-bs-toggle="collapse" href="#direct-p" role="button" aria-expanded="false" aria-controls="collapseExample" className="collapsed" />
                                        <label htmlFor="direct">Direct Bank Transfer</label>
                                    </li>
                                    <li>
                                        <div className="collapse" id="direct-p">
                                            <div className="card card-body">
                                                <p className=" p-same-p">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                                                    ea commodo
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <input type="radio" name="direct" id="cp" data-bs-toggle="collapse" href="#payment-pp" role="button" aria-expanded="false" aria-controls="collapseExample" className="collapsed" />
                                        <label htmlFor="cp">Check Pyaments</label>
                                    </li>
                                    <li>
                                        <div className="collapse" id="payment-pp">
                                            <div className="card card-body">
                                                <p className=" p-same-p">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                                                    ea commodo
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <input type="radio" name="direct" id="cod" data-bs-toggle="collapse" href="#dilivery-pp" role="button" aria-expanded="false" aria-controls="collapseExample" className="collapsed" />
                                        <label htmlFor="cod">Cash On Delivery</label>
                                    </li>
                                    <li>
                                        <div className="collapse" id="dilivery-pp">
                                            <div className="card card-body">
                                                <p className=" p-same-p">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                                                    ea commodo
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <input type="radio" name="direct" id="paypal" data-bs-toggle="collapse" href="#paypal-pp" role="button" aria-expanded="false" aria-controls="collapseExample" className="collapsed" />
                                        <label htmlFor="paypal">Paypal</label>
                                    </li>
                                    <li>
                                        <div className="collapse" id="paypal-pp">
                                            <div className="card card-body">
                                                <p className=" p-same-p">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                                                    ea commodo
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className="check-out-btn text-center">
                                    <Link to="" className="theme-btn-1">Place Order </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Checkout